import { queryAll } from './dom.js';

// Volume-priced widgets (single-address) point at the [data-qty][data-price]
// rows already rendered in the "See volume pricing" popup via
// data-tiers-source="#some-dialog-id" so the price beside the stepper can be
// kept in sync as the customer types. Flat-priced widgets (multi-address)
// carry no data-tiers-source and are untouched.
function parseTiers(widget) {
  const sourceSelector = widget.dataset.tiersSource;
  if (!sourceSelector) return null;
  const source = document.querySelector(sourceSelector);
  if (!source) return null;
  const tiers = queryAll('[data-qty][data-price]', source).map(el => ({
    qty:   parseInt(el.dataset.qty, 10),
    price: el.dataset.price,
  }));
  return tiers.length ? tiers.sort((a, b) => a.qty - b.qty) : null;
}

function priceForQty(tiers, qty) {
  let tier = tiers[0];
  for (const t of tiers) {
    if (t.qty <= qty) tier = t;
  }
  return tier.price;
}

function minFor(widget) {
  return parseInt(widget.dataset.min, 10) || 1;
}

function inputFor(widget) {
  return widget.querySelector('.parcel-quantity__input');
}

function clamp(widget, qty) {
  const min = minFor(widget);
  return Math.max(min, qty || min);
}

// Sync the widget's UI to qty without notifying anyone.
function render(widget, qty) {
  inputFor(widget).value = qty;
  widget.querySelector('.parcel-quantity__btn--minus').disabled = qty <= minFor(widget);

  const tiers    = parseTiers(widget);
  const amountEl = widget.querySelector('.parcel-quantity__amount');
  if (tiers && amountEl) {
    amountEl.textContent = `£${priceForQty(tiers, qty)}`;
  }
}

// Sync the UI and tell listeners (e.g. the basket) the quantity changed.
function setQty(widget, qty) {
  render(widget, qty);
  widget.dispatchEvent(new CustomEvent('quantityUpdated', {
    detail: { qty },
    bubbles: true
  }));
}

let listenersBound = false;

// Listeners are delegated from document and bound once, so widgets swapped
// in later (e.g. by htmx) work without any re-initialisation.
function bindListeners() {
  if (listenersBound) return;
  listenersBound = true;

  document.addEventListener('click', e => {
    const btn = e.target.closest('.parcel-quantity__btn');
    if (!btn || btn.disabled) return;
    const widget = btn.closest('.parcel-quantity');
    if (!widget) return;

    const current = parseInt(inputFor(widget).value, 10) || minFor(widget);
    const delta   = btn.classList.contains('parcel-quantity__btn--plus') ? 1 : -1;
    const next    = clamp(widget, current + delta);
    if (next !== current) setQty(widget, next);
  });

  document.addEventListener('change', e => {
    if (!e.target.matches('.parcel-quantity__input')) return;
    const widget = e.target.closest('.parcel-quantity');
    if (!widget) return;
    setQty(widget, clamp(widget, parseInt(e.target.value, 10)));
  });
}

export function initParcelQuantity() {
  const widgets = queryAll('.parcel-quantity');
  if (!widgets.length) return;

  widgets.forEach(widget => {
    render(widget, clamp(widget, parseInt(inputFor(widget).value, 10)));
  });
  bindListeners();
}